const TOWER_HATS = [
  {
    slug: "tower-blue-33",
    name: "Tower",
    description: "One of the elite",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 20
      },
      {
        stat: "blueRes",
        value: 10
      },
      {
        stat: "goldColor",
        value: 6
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 33
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "tower-green-33",
    name: "Tower",
    description: "One of the elite",
    rarity: "uncommon",
    slot: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 10
      },
      {
        stat: "greenRes",
        value: 5
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 33
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "tower-pink-33",
    name: "Tower",
    description: "One of the elite",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 20
      },
      {
        stat: "goldRes",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 33
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "tower-red-33",
    name: "Tower",
    description: "One of the elite",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 20
      },
      {
        stat: "redRes",
        value: 10
      },
      {
        stat: "blackColor",
        value: 6
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 33
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "tower-yellow-33",
    name: "Tower",
    description: "One of the elite",
    rarity: "uncommon",
    slot: "hat",
    statChanges: [
      {
        stat: "goldColor",
        value: 10
      },
      {
        stat: "goldRes",
        value: 5
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_yellow",
      frameIndex: 33
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  }
];
export {
  TOWER_HATS
};
//# sourceMappingURL=data:application/json;base64,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
